import { render } from "./prenotaAppuntamentoModal.vue?vue&type=template&id=d52c8e84&scoped=true&ts=true"
import script from "./prenotaAppuntamentoModal.vue?vue&type=script&lang=ts"
export * from "./prenotaAppuntamentoModal.vue?vue&type=script&lang=ts"

import "./prenotaAppuntamentoModal.vue?vue&type=style&index=0&id=d52c8e84&scoped=true&lang=css"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d52c8e84"]])

export default __exports__